import React from 'react';
import PropTypes from 'prop-types';

import {
	StudienberatungBlockWrapper,
	LinkItemWrapper,
	LinkItem,
	ContentList,

	// eslint-disable-next-line import/no-unresolved
} from './custom.styled.UNIVERSITY';
import { useSalesForce } from '@src/scripts/util/salesForce';
import TabsBlock from '@src/scripts/components/TabsBlock/component';
import TabsItemBlock from '@src/scripts/components/TabsItemBlock/component';
import cleanForSlug from '@src/scripts/util/cleanForSlug';
import { Nav } from '@src/scripts/components/TabsBlock/custom.styled';
import { Col, Row } from '@src/scripts/styled-components/Layout';
import SVG from '@src/scripts/components/SVGs';
import renderRichText from '@src/scripts/util/renderRichText';

// eslint-disable-next-line import/no-unresolved
import { Image } from './Image.UNIVERSITY';
import { isCfh, isSiteFamily } from '@src/scripts/util/site';

//Examples for RichTexts, InnerBlocks and Icons in ExampleComponent

const StudienberatungBlock = ( {
	isCustom = false,
	blockTheme = 'primary',
	...rest
} ) => {
	const itemProps = { ...rest, isCustom };
	return (
		<StudienberatungBlockWrapper
			//ref={ ref } //for update react-habitat
			className={ `dhsv-studienberatung-block theme-${ blockTheme }` } //important for e2e tests // remove placeholder-block when start building
			blockTheme={ blockTheme }
		>
			{ /* eslint-disable-next-line no-nested-ternary */ }
			{ isCustom ? (
				<BeraterItem { ...itemProps } />
			) : (
				<BeraterItemWithSalesforce { ...itemProps } />
			) }
		</StudienberatungBlockWrapper>
	);
};

const BeraterItemWithSalesforce = ( {
	websiteCode,
	abschlussartKurz,
	studiengangsformKurz,
	paidLandingpage,
	salesforceId,
	...props
} ) => {
	const { beratung } = useSalesForce( {
		websiteCode,
		abschlussartKurz,
		studiengangsformKurz,
		paidLandingpage,
		salesforceId,
	} );

	if ( ! beratung.length ) {
		return null;
	}

	return beratung.length === 1 ? (
		<BeraterItem
			{ ...beratung[ 0 ] }
			foto={ { url: beratung[ 0 ].foto } }
			isEditor={ props.isEditor }
			l10n={ props.l10n }
			iconColor={ props.iconColor }
		/>
	) : (
		<TabsBlock
			layout={ {
				justifyContent: 'left',
				orientation: 'horizontal',
			} }
			selected={ 0 }
		>
			<Nav className={ 'tabs-nav alignleft' }>
				{ beratung.map( ( item, key ) => (
					<div key={ key }>
						<TabsItemBlock
							title={ item.standort }
							slug={ cleanForSlug( item.standort ) }
							tabsCount={ beratung.length }
						>
							<BeraterItem
								{ ...item }
								foto={ { url: item.foto } }
								isEditor={ props.isEditor }
								l10n={ props.l10n }
								iconColor={ props.iconColor }
							/>
						</TabsItemBlock>
					</div>
				) ) }
			</Nav>
		</TabsBlock>
	);
};

const BeraterItem = ( {
	name,
	subline,
	text,
	standort,
	telefon,
	mail,
	whatsapp,
	whatsappUrl,
	foto = {},
	isEditor,
	isCustom,
	iconColor = '',
	l10n = {
		subline: '',
		text: {
			description: '',
			schedule: '',
		},
	},
} ) => {
	subline = isCustom
		? subline
		: `${ l10n?.subline || '' } ${ standort || '' }`;
	text = isCustom
		? text
		: `${ l10n.text.description } </br> ${ l10n.text.schedule }`;

	let pnoneIconName = 'IosTelephoneOutline';
	let mailIconName = 'IosEmailOutline';
	let whatsAppIconName = 'AndroidTextsms';
	let iconType = 'ion';

	if ( isCfh ) {
		pnoneIconName = 'PhoneOutline';
		mailIconName = 'EmailOutline';
		whatsAppIconName = 'QuoteOutline';
		iconType = 'cfh';
	} else if ( isSiteFamily( 'crms' ) ) {
		pnoneIconName = 'Phone';
		mailIconName = 'SolidEmail';
		whatsAppIconName = 'WhatsApp';
		iconType = 'crms';
	}

	return (
		<Row mobileDirection={ 'column-reverse' }>
			<Col size={ `${ isSiteFamily( 'crms' ) ? '7' : '9' }` }>
				<ContentList
					style={ {
						display: 'flex',
						flexDirection: 'column',
					} }
				>
					<div>
						{ renderRichText( name, 'h3' ) }
						{ renderRichText( subline, 'p', {
							className: 'subline',
						} ) }
					</div>
					<div>
						{ renderRichText( text, 'p', {
							className: 'has-input-font-size stud-text',
						} ) }
					</div>
					{ ( telefon || mail || whatsapp ) && (
						<LinkItemWrapper iconColor={ iconColor }>
							{ telefon && (
								<LinkItem
									as={ isEditor ? 'span' : 'a' }
									{ ...( isEditor
										? {}
										: { href: 'tel:' + telefon } ) }
								>
									<SVG
										icon={ pnoneIconName }
										type={ iconType }
									/>
									{ renderRichText( telefon, 'span' ) }
								</LinkItem>
							) }
							{ mail && (
								<LinkItem
									as={ isEditor ? 'span' : 'a' }
									{ ...( isEditor
										? {}
										: { href: 'mailto:' + mail } ) }
								>
									<SVG
										icon={ mailIconName }
										type={ iconType }
									/>

									{ renderRichText( mail, 'span' ) }
								</LinkItem>
							) }
							{ whatsapp && (
								<LinkItem
									as={ isEditor ? 'span' : 'a' }
									{ ...( isEditor
										? {}
										: { href: whatsappUrl } ) }
								>
									<SVG
										icon={ whatsAppIconName }
										type={ iconType }
									/>

									{ renderRichText( whatsapp, 'span' ) }
								</LinkItem>
							) }
						</LinkItemWrapper>
					) }
				</ContentList>
			</Col>
			{ foto.url && (
				<Col
					size={ `${ isSiteFamily( 'crms' ) ? '5' : '3' }` }
					style={ { position: 'relative' } }
				>
					<Image foto={ foto } standort={ standort } l10n={ l10n } />
				</Col>
			) }
		</Row>
	);
};

StudienberatungBlock.propTypes = {
	isMobile: PropTypes.bool,
	iconColor: PropTypes.string,
};

export default StudienberatungBlock;
